"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USERS_ROUTES = exports.PREFIX = void 0;
exports.PREFIX = "/users";
exports.USERS_ROUTES = {
    auth: () => `${exports.PREFIX}/auth`,
    register: () => `${exports.PREFIX}/register`,
    me: () => `${exports.PREFIX}/me`
};
//# sourceMappingURL=users.api.js.map